import Router from "@services/router";
import ClubPage from "./components/pages/Club";
import MembersPage from "./components/pages/Members";
import ClubEditPage from "./components/pages/ClubEdit";
import InvitePage from "./components/pages/Invite";
import PromosPage from "./components/pages/Promos";
import SalonsPage from "./components/pages/Salons";
import MemberPage from "./components/pages/Member";
import SalonPage from "./components/pages/Salon";
import owner from "./middleware/owner";

export default [
    Router.page({ name: "club:customer", path: "/app/group", component: ClubPage }),
    Router.page({ name: "club:customer:create", path: "/app/group/create", component: ClubEditPage }),
    Router.group({ middleware: owner() }, [
        Router.page({ name: "club:owner:edit", path: "/app/group/edit", component: ClubEditPage }),
        Router.page({ name: "club:owner:members", path: "/app/group/members", component: MembersPage }),
        Router.page({ name: "club:owner:member", path: "/app/group/members/:id", component: MemberPage }),
        Router.page({ name: "club:owner:salons", path: "/app/group/salons", component: SalonsPage }),
        Router.page({ name: "club:owner:salon", path: "/app/group/salons/:id", component: SalonPage }),
        Router.page({ name: "club:owner:discounts", path: "/app/group/discounts", component: PromosPage }),    
    ])
]